// extracted by mini-css-extract-plugin
export default {"card":"AddValueToSelectedOption_card__o8PB0","configLabel":"AddValueToSelectedOption_configLabel__m7rph"};